import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Home.module.css';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const PricingCTA = () => (
  <section className={styles.sec} id="pricing" style={{ textAlign: 'center' }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />Pricing</span>
        <h2>Free to get started.</h2>
        <p className={styles.secLead}>No setup fees and no monthly minimums — pay only when you get paid. See full pricing for the details.</p>
        <div className={`${styles.pricingCta} ${styles.sr}`} data-sr>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <Link to="/pricing" className={styles.btnOutline}>See pricing</Link>
        </div>
      </div>
    </div>
  </section>
);

export default PricingCTA;
